<template>
  <!-- eslint-disable max-len -->
  <div class="training-sessions scrollbar">
    <div
      class="training-sessions__list-item card"
    >
      <div class="statistics">
        <div class="training-sessions__header" @click="handleSessionInfoClick">
          <div class="statistics">
            <div class="header">
              <div class="left">
                <input
                  type="checkbox"
                  :checked="isSelected"
                  @change="toggleSelection()"
                  @click.stop
                  v-tooltip="`Select session`"
                  style="margin: 0; cursor: pointer; width: 18px; height: 18px; flex-shrink: 0;"
                />
                <div class="icon-container">
                  <v-icon v-if="isDetect()" v-tooltip="`Detection`">mdi-account-box-multiple-outline</v-icon>
                  <v-icon v-if="isSegment()" v-tooltip="`Segmentation`">mdi-hexagon-multiple</v-icon>
                  <v-icon v-if="isFusion()" v-tooltip="`Fusion`">mdi-radar</v-icon>
                  
                </div>

         
                <!-- <span class="section-title">{{ manageType(session) }}</span> -->
              </div>
              <div class="right">
                <div class="icon-container">
                 
                  <IconButton
                    v-if="!isPublicRoute"
                    v-tooltip="`Clone Training Session`"
                    class="icon maximize-icon"
                    :icon="'copy'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="cloneTask()"
                  />
                  <IconButton
                    v-if="canResume()"
                    v-tooltip="`Resume Trainer`"
                    class="icon resume-icon"
                    :icon="'play_circle'"
                    :width="24"
                    :height="24"
                    :type="'click'"
                    @click.stop="resumeTask()"
                  />
                  <IconButton
                    v-if="isShowCharts()"
                    v-tooltip="`View charts for training session`"
                    class="icon analytics-icon"
                    :icon="'analytics'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="handleShowChartsClick()"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write && isStoppable()"
                    v-tooltip="`Terminate training session. This will stop training, but you can still view train artifacts`"
                    class="icon stop-icon"
                    :icon="'stop_circle'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="terminateTask()"
                  />

                  <div class="trainer-card-menu" @click.stop>
                    <BaseMenu :placement="'bottom-end'">
                    <IconButton
                      class="icon"
                      :icon="'more_vert'"
                      :width="22"
                      :height="22"
                      :type="'click'"
                      @click.stop
                    />
                    <template #menu="{ closeMenu }">
                      <ul class="trainer-menu">
                        <li><BaseMenuButton @click.stop="$emit('card-action', { action: 'details', session }), closeMenu()">Training Details</BaseMenuButton></li>
                        <li v-if="permissions?.trainer_write"><BaseMenuButton @click.stop="$emit('card-action', { action: 'edit', session }), closeMenu()">Edit Name</BaseMenuButton></li>
                        <li v-if="permissions?.trainer_write"><BaseMenuButton @click.stop="$emit('card-action', { action: 'delete', session }), closeMenu()">Delete Session</BaseMenuButton></li>
                        <li v-if="permissions?.trainer_write && canResume()"><BaseMenuButton @click.stop="$emit('card-action', { action: 'resume', session }), closeMenu()">Resume Session</BaseMenuButton></li>
                        <li v-if="permissions?.trainer_write"><BaseMenuButton @click.stop="$emit('card-action', { action: 'move', session }), closeMenu()">Move Session</BaseMenuButton></li>
                        <li v-if="!isPublicRoute"><BaseMenuButton @click.stop="$emit('card-action', { action: 'clone', session }), closeMenu()">Clone Session Params</BaseMenuButton></li>
                        <li v-if="isShowCharts()"><BaseMenuButton @click.stop="$emit('card-action', { action: 'charts', session }), closeMenu()">Charts</BaseMenuButton></li>
                        <li><BaseMenuButton @click.stop="$emit('card-action', { action: 'artifacts', session }), closeMenu()">Artifacts</BaseMenuButton></li>
                      </ul>
                    </template>
                    </BaseMenu>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body scrollbar" @click="handleSessionInfoClick">
          <TaskData
            :session="session.docker_task || {}"
            :task-name="session.name || ''"
            :start-date="session.docker_task ? formatTime(session.docker_task.date) : ''"
            :duration="session.docker_task?.formatted_duration || ''"
            :user-list="userList"
            :permissions="permissions"
            :session-status="session.docker_task?.status || ''"
            :status-info="session.docker_task?.status_info || {}"
            :message="session.docker_task?.message || ''"
            :task-u-i-d="session.docker_task?.id ? `bt-${Number(session.docker_task.id).toString(16)}` : ''"
            :user-name="session.docker_task?.username || ''"
            :parent-u-i-d="''"
            :process-info="session.docker_task?.status_process_info || { id: '', status: '' }"
            @card-click="handleSessionInfoClick"
            @logs="handleLogsClick"
          />
          <div class="body__grid" v-tooltip:top="'Click to see details'">
            <div class="body__grid-field">
              <div class="description">Dataset</div>
              <div class="value hyperlink" @click.stop="navigateToDataset()">
                {{ session.params.trainer_params ? session.params.trainer_params['dataset_name'] : 'Unknown' }}
              </div>
            </div>
             <div class="body__grid-field" v-if="session.model">
              <div class="description">Model</div>
              <div class="value"><span >{{ session.model }}</span></div>
            </div>
            <!-- Type can be in model name or model size -->
            <div class="body__grid-field" v-if="session.params?.model_params?.model?.model_size">
              <div class="description">Type</div>
              <div class="value"><span >{{ session.params?.model_params?.model?.model_size }}</span></div>
            </div>
            <div class="body__grid-field" v-if="session.params?.model_params?.model?.model_name">
              <div class="description">Type</div>
              <div class="value"><span >{{ session.params?.model_params?.model?.model_name }}</span></div>
            </div>
            
            <div class="body__grid-field" v-if="session.params?.model_params?.input?.size ">
              <div class="description">Size</div>
              <div class="value"><span >{{ session.params?.model_params?.input?.size }}</span></div>
            </div>
          </div>
            <div class="description-separator" />
            <DescriptionField
              v-if="!isPublicRoute"
              :text="session.description"
              :clickable="true"
              :data="session"
              @description-changed="handleDescriptionChanged"
            />
            <div v-else class="description-readonly">
              {{ session.description || '(no description)' }}
            </div>
            <hr class="trainer-id-separator">
            <div class="owner-id-display">
              <EncodedIdField
                :id="session.id"
                :type="'trainer'"
                :hideLabel="false"
                :single-line="true"
                :label-override="'Training Session:'"
              />
            </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TrainingChartSingle from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainingChartSingle';
import IconButton from '@/components/IconButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import EncodedIdField from '@/components/EncodedIdField.vue';
import TaskStatusBars from '@/components/TaskStatusBars.vue';
import TaskData from '@/components/Apps/TaskData.vue';
import DescriptionField from '@/components/Cards/DescriptionField.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import { Controls } from 'three';

export default {
  name: "TrainerCard",
  components: {
    IconButton,
    SVGIcon,
    EncodedIdField,
    TaskStatusBars,
    TaskData,
    TrainingChartSingle,
    DescriptionField,
    BaseMenu,
    BaseMenuButton,
  },
  props: {
    session: {
      type: Object,
      required: true,
    },
    currentProject: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['clone-training-session', 'show-trainer-details', 'create-trainer-session', 'info-clicked', 'charts-clicked', 'analytics-clicked', 'terminate-session', 'delete-trainer', 'delete-session', 'edit-trainer', 'refresh-session', 'session-selected', 'resume-training-session', 'description-changed'],
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      show_menu: false,
      hiddenProgress: [],
      sessionStatusList: {},
      isSelected: false,
    };
  },
  computed: {
    userList() {
      return this.$store.state.user.userList;
    },
    isPublicRoute() {
      return this.$route?.path?.includes('/public');
    },
  },
  mounted() {
    this.getStatus(this.session);
  },
  methods: {
    isDetect() {
      return (
        this.session.params?.model_params?.model?.detection || 
        this.session.params?.model_params?.model?.model_task === 'detection'
      );
    },
    isSegment() {
      return (
        this.session.params?.model_params?.model?.segmentation || 
        this.session.params?.model_params?.model?.model_task === 'segmentation'
      );
    },
    isFusion() {
      return (this.session.trainer_params?.task=='fusion');
    },
    isCloud() {
      return (this.session.docker_task?.manage_type=='' || this.session.docker_task?.manage_type=='aws' );
    },
    isUserManaged() {
      return (this.session.docker_task.manage_type=='user');
    },
    isKubernetes() {
      return (this.session.docker_task.manage_type=='kubernetes');
    },

    showProgress() {
      if (!this.session) return false;
      const task = this.session.docker_task;
      if (task.status.toLowerCase().includes('complete')) return false;
      if (task.status.toLowerCase().includes('error')) return false;
      if (task.status.toLowerCase().includes('terminated')) return false;
      if (task.data.length < 4) return false;
      return true;
    },
    manageType(v) {
      if (!v) return "-";
      const type = v.docker_task.manage_type;
      if (type == '') return "Cloud";
      if (type == 'aws') return "Cloud";
      if (type == 'user') return "User Managed";
      if (type == 'kubernetes') return "Kubernetes";
      return "--";
    },
    hasMetrics() {
      // return this.session && this.session.metrics && Object.keys(this.session.metrics).length > 0;
      return false;
    },
    hasResults() {
      return this.session && this.session.results && Object.keys(this.session.results).length > 0;
    },
    toggleHideProgress(v, id) {
      const index = this.hiddenProgress.indexOf(id);
      if (v) {
        this.hiddenProgress.push(id); // Add if not
      } else {
        if (index > -1) {
          this.hiddenProgress.splice(index, 1); // Remove if exists
        }
      }
    },
    handleSessionInfoClick() {
      this.$emit("info-clicked", this.session);
    },
    handleShowChartsClick() {
      this.$emit('charts-clicked', this.session);
    },
    handleEditTrainerClick() {
      this.$emit('edit-trainer', this.session);
    },
    handleDescriptionChanged(description) {
      this.$emit('description-changed', {
        session: this.session,
        description,
      });
    },
    getStatus(session) {
      this.sessionStatusList[session.id] = session.docker_task.status;
    },
    getMessage(session) {
      if (session && session.docker_task) {
        return session.docker_task.message;
      }
      return null;
    },
    getCount(session) {
      if (session && session.docker_task) {
        return session.docker_task.count;
      }
      return null;
    },
    getTotal(session) {
      if (session && session.docker_task) {
        return session.docker_task.total;
      }
      return null;
    },
    getEndTime(docker_task) {
      if (docker_task.end_date !== "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = new Date(docker_task.end_date) - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else if (docker_task.end_date === "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = Date.now() - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else {
        return null;
      }
    },
    formatTime(str) {
      return `${new Date(str).toLocaleTimeString('default', {
        year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
      })}`;
    },
    terminateTask() {
      this.$emit('terminate-session', this.session);
    },
    deleteTask() {
      this.$emit('delete-session', this.session);
    },
    cloneTask() {
      this.$emit('clone-training-session', this.session);
    },
    resumeTask() {
      this.$emit('resume-training-session', this.session);
    },
    handleDeleteTrainer() {
      this.$emit('delete-trainer');
    },
    handleRefresh() {
      this.$emit('refresh-session', this.session);
    },
    parseMPKShape(shape) {
      if (!shape) {
        return "";
      }
      const split = shape.split(",");
      return [split[1], split[0]].join(",");
    },
    canResume() {
      if (!this.session || !this.session.docker_task || !this.session.docker_task.status) return false;
      if(this.session.docker_task.status.toLowerCase().includes('terminated')) return true;
      if(this.session.docker_task.status.toLowerCase().includes('error')) return true;
      if(this.session.docker_task.status.toLowerCase().includes('deleted')) return true;
      return false;
    },
    isStoppable() {
      if (!this.session || !this.session.docker_task || !this.session.docker_task.status) return true;
      const status = this.session.docker_task.status.toLowerCase();
      return !status.includes('error') && !status.includes('complete') && !status.includes('deleted') && !status.includes('terminated');
    },
    isShowCharts() {
      if (!this.session || !this.session.docker_task || !this.session.docker_task.status) return false;
      if(this.session.docker_task.status.toLowerCase().includes('deleted')) return true;
      return true;
    },
    toggleSelection() {
      this.isSelected = !this.isSelected;
      this.$emit('session-selected', {
        sessionId: this.session.id,
        isSelected: this.isSelected,
      });
    },
    navigateToDataset() {
      const dsID = this.session.params?.dataset_params?.['dataset_id'];
      if (dsID) {
        this.$router.push({
          name: 'datasets.gallery.new',
          params: { datasetId: Number(dsID).toString(16) },
        });
      } else {
        console.warn('Dataset ID not found. Session params:', this.session.params);
      }
    },
    handleLogsClick() {
      const taskId = this.session.docker_task?.id;
      if (taskId === undefined || taskId === null) {
        return;
      }
      this.$router.push({ name: 'logs', params: { task_id: `bt-${Number(taskId).toString(16)}` } });
    },
  },
};
</script>

<style scoped lang="scss">
.trainer-card-menu {
  order: 10;
}
</style>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 460px;
  padding: 0;
  margin: 0;
  text-align: left;
  border-radius: 8px;

  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.description-readonly {
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  font-style: italic;
  padding-top: 4px;
  color: rgb(4, 52, 124);
  width: 100%;
}

.description-separator {
  width: 100%;
  border-top: 1px solid #d0d0d0;
  margin: 0;
}

.trainer-id-separator {
  width: 100%;
  border: 0;
  border-top: 1px solid #d0d0d0;
  margin: 6px 0 4px;
}


.trainer-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  min-width: 200px;
}

.training-sessions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  

  &__list-item {
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    cursor: pointer;
  }

  &__header {
    display: flex;
    flex-direction: row;
    padding: 4px 16px;
    background: var(--gray-200);
    height: 32px;
  }

  .progress {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 350px;
    // width: min(30%, 400px);
    // max-width: min(30%, 400px);
  }
  .statistics {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 350px;
    // width: min(30%, 500px);
    // max-width: min(40%, 500px);
  }
  .metrics {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 300px;
    max-width: 600px;
    // width: min(20%, 500px);
    // max-width: min(40%, 500px);
  }
  .charts {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 300px;
    max-width: 600px;
  }

  .left {
    width: 50%;
    min-width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .right {
    width: 50%;
    min-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  height: 32px;
}

.body {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  padding: 6px 10px 10px;
  overflow: auto;
  cursor: pointer;

  .owner-id-display {
    display: flex;
    flex-direction: row;
    width: 100%;

    .labels-container {
      flex: 1;
    }
  }

  &__grid-field {
    display: flex;
    flex-direction: row;
    margin-top: 0px;
  }

  &__grid {
    display: block;

    .description {
      font-size: 0.78rem;
      font-weight: 600;
      color: var(--body-text-color);
      width: 100px;
      min-width: 100px;
    }
    .value {
      font-size: 0.78rem;
      font-weight: 500;
      color: var(--body-text-color-secondary);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &__description {
    flex: 1;
    white-space: normal;
    font-style: italic;
    color: #5a7a94;
    font-size: 11px;
    line-height: 1.4;
    border-top: 1px solid #d0d0d0;
    margin-top: 4px;
    padding-top: 4px;
  }

  &._separator::after {
    content: "";
    position: absolute;
    right: 0;
    top: 5%;
    bottom: 5%;
    width: 1px;
    background-color: #9a9ca2;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  margin-left: 10px;
  gap: 8px;
  @include themify() {
    color: themed('body-text-color-secondary');
  }
  .icon + .icon {
    margin-left: 0px;
  }
  .icon-label {
    cursor: arrow;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  line-height: 1;
  font-size: 20px;
  @include themify() {
    color: themed('body-text-color-secondary');
  }
}

.icon:hover {
  @include themify() {
    color: themed('color-primary');
    background: themed('icon-hover-color');
    border-radius: 100%;
    box-shadow: 0 0 0 4px themed('icon-hover-color');
  }
}

.icon.delete:hover {
  color: var(--color-error)
}

.vertical-separator {
  width: 1px;
  height: 80%;
  background-color: #9a9ca2;

  margin-top: auto;
  margin-bottom: auto
}

.trainer-id-field {
  margin-right: 20px;
}

:deep() {
  .v-expansion-panel__shadow {
    box-shadow: none !important;
  }
}

.section-title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 1rem;
  font-weight: 700;
  color: var(--body-text-color-heading);
  letter-spacing: 0.025em;
  gap: 6px;
}

.training-sessions-empty {
  display: flex;
  flex-direction: column;
  height: 150px;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: bold;
  border: solid 1px black;
  border-radius: 8px;
  @include themify() {
    background: radial-gradient(circle, rgba($color-primary-300, 0.075) 50%, rgba(var(--color-primary-rgb), 0.125) 100%);
  }

  span {
    padding: 16px;
    text-align: center;
  }
}

.training-chart-container {
  padding: 5px;
  height: 100%;
  overflow: hidden;
}

</style>

